import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Ai } from "@air/next-icons";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { useMountedState } from "__barrel_optimize__?names=useMountedState!=!react-use";
import { useCloseAssetModal } from "~/components/AssetModal/shared/useCloseAssetModal";
import { useSearchParams } from "~/hooks/search/useSearchParams";
import { centralizedClipKeywordsSelector, centralizedClipSummarySelector } from "~/store/centralizedClip/selectors";
import { InfoPanelDetailsSection } from "../shared/InfoPanelDetailsSection";
import { InfoPanelSummaryDisclaimer } from "./component/InfoPanelSummaryDisclaimer";
import { InfoPanelSummaryKeywordList } from "./component/InfoPanelSummaryKeywordList";
import { InfoPanelSummaryText } from "./component/InfoPanelSummaryText";
export const InfoPanelSummaryDetails = /*#__PURE__*/ memo((param)=>{
    let { onRemoveKeyword } = param;
    const keywords = useSelector(centralizedClipKeywordsSelector);
    const summary = useSelector(centralizedClipSummarySelector);
    const isMounted = useMountedState();
    const { closeAssetModal } = useCloseAssetModal();
    const { setSearch } = useSearchParams();
    const onClick = useCallback(async (label)=>{
        await setSearch(label);
        if (isMounted()) {
            closeAssetModal();
        }
    }, [
        closeAssetModal,
        isMounted,
        setSearch
    ]);
    if (!summary && !(keywords === null || keywords === void 0 ? void 0 : keywords.length)) return null;
    return /*#__PURE__*/ _jsxs(InfoPanelDetailsSection, {
        Icon: Ai,
        title: "AI Summary",
        children: [
            /*#__PURE__*/ _jsx(InfoPanelSummaryText, {
                summary: summary
            }),
            /*#__PURE__*/ _jsx(InfoPanelSummaryKeywordList, {
                keywords: keywords,
                onKeywordClick: onClick,
                onRemoveKeyword: onRemoveKeyword
            }),
            /*#__PURE__*/ _jsx(InfoPanelSummaryDisclaimer, {
                summary: summary,
                keywords: keywords
            })
        ]
    });
});
InfoPanelSummaryDetails.displayName = "InfoPanelSummaryDetails";
